import React from "react";

import { RekognitionResultItem } from "../listing/RekognitionResultItem";

export interface VideoRekognitionResultContext {
    cloudFileId: string;
    items: RekognitionResultItem[];
    setItems(items: RekognitionResultItem[]): void;
    selectedItems: RekognitionResultItem[];
    setSelectedItems(seletedItems: RekognitionResultItem[]): void;
    updateItem(key: string, startTimestamp: number, endTimestamp: number): void;
    showRekognitionPreview: boolean;
    isLoading: boolean;
}

export const VideoRekognitionResultContext = React.createContext<VideoRekognitionResultContext>(
    {} as VideoRekognitionResultContext
);
